<template>
  <v-card class="assign-module-card">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-header__icon-wrap">
          <v-icon class="modal-header__icon">business</v-icon>
        </div>
        <div>
          <div class="modal-header__title">Assign Module</div>
          <div class="modal-header__sub module-name" v-if="mod && mod.module">
            {{ mod.module.replace(/_/g, ' ').toUpperCase() }}
          </div>
        </div>
      </div>
    </div>

    <v-divider class="modal-divider"></v-divider>

    <div class="modal-body">
      <div class="form-field-label">Module</div>
      <v-text-field
        v-model="mod.module"
        outline
        readonly
        class="module-input mb-3"
        prepend-inner-icon="extension"
      ></v-text-field>

      <div class="form-field-label">Assign to Schools</div>
      <v-combobox
        v-model="mod.companies"
        :items="companies"
        label="Select schools..."
        chips
        clearable
        solo
        multiple
        item-text="company_name"
        item-value="company_id"
        class="company-combobox"
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
            close
            @input="remove(data.item)"
            class="company-chip"
          >
            <v-icon left small>school</v-icon>
            {{ data.item.company_name }}
          </v-chip>
        </template>
      </v-combobox>
    </div>

    <v-divider class="modal-divider"></v-divider>
    <div class="modal-footer">
      <v-btn flat class="modal-cancel-btn" @click="$emit('exit')">Cancel</v-btn>
      <v-btn depressed color="primary" class="modal-action-btn" @click="assignModule">
        <v-icon left small>check</v-icon>Assign
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import APICompany from "@/mixins/APICompany";
import APIModule from "@/mixins/APIModule";
export default {
  mixins: [APICompany, APIModule],
  props: ["mod"],
  data() {
    return {
      companies: [],
      assignCompanyList: [],
      module: { companies: [] }
    };
  },
  watch: {
    mod: {
      handler: function(value) {
        this.module = value;
      },
      immediate: true
    }
  },
  created() {
    this.handleGetCompany();
  },
  methods: {
    remove(item) {
      if (this.mod.companies) {
        const idx = this.mod.companies.indexOf(item);
        if (idx >= 0) this.mod.companies.splice(idx, 1);
      }
    },
    assignModule: async function() {
      var mod = { company: "", modules: [this.module.module] };
      if (!this.module.companies || this.module.companies.length == 0) return;
      else if (this.module.companies.length == 1) {
        mod.company = this.module.companies[0]._id;
        mod.modules = [this.module.module].concat(this.module.companies[0].modules);
        this.module.companies[0].modules = mod.modules;
      } else {
        this.assignCompanyList = this.module.companies;
        this.handleMultipleCompaniesAssignment();
        return;
      }
      try {
        mod.modules = Array.from(new Set(mod.modules));
        await this.assignModulesToCompany(mod);
        await this.handleGetCompany();
      } catch (error) {
        this.$toast.error("Failed to assign company details.", "Error", { position: "topCenter" });
      }
    },
    handleMultipleCompaniesAssignment: async function() {
      if (this.assignCompanyList.length == 0) {
        this.$toast.success("Modules added successfully.", "Success", { position: "topCenter" });
        await this.handleGetCompany();
        return;
      }
      let company = this.assignCompanyList.pop();
      if (company) {
        var mod = { company: company._id, modules: [this.module.module].concat(company.modules) };
        mod.modules = Array.from(new Set(mod.modules));
        try {
          await this.assignModulesToCompany(mod);
          this.handleMultipleCompaniesAssignment();
        } catch (error) {
          this.handleMultipleCompaniesAssignment();
        }
      }
    },
    handleGetCompany: async function() {
      try {
        this.companies = await this.getCompanies();
      } catch (error) {}
    }
  }
};
</script>

<style scoped lang="css">
.assign-module-card { border-radius: 16px !important; overflow: hidden; }

.modal-header {
  display: flex; align-items: center; padding: 20px 20px 16px;
}
.modal-header__left { display: flex; align-items: center; gap: 14px; }
.modal-header__icon-wrap {
  width: 42px; height: 42px; border-radius: 12px;
  background: linear-gradient(135deg, #1565C0, #0d47a1);
  display: flex; align-items: center; justify-content: center;
}
.modal-header__icon { color: #ffffff !important; font-size: 20px !important; }
.modal-header__title {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 16px;
  font-weight: 700; color: #1e293b;
}
.modal-header__sub { font-family: 'Inter', 'Roboto', sans-serif; font-size: 12px; color: #94a3b8; margin-top: 2px; }
.module-name {
  background: rgba(21,101,192,0.08); color: #1565C0;
  padding: 2px 8px; border-radius: 6px; font-weight: 600;
}
.modal-divider { border-color: #f1f5f9 !important; }

.modal-body { padding: 20px; }
.form-field-label {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 13px;
  font-weight: 600; color: #475569; margin-bottom: 6px;
}
.module-input >>> .v-input__slot { background: #f8fafc !important; border-radius: 10px !important; }
.company-combobox >>> .v-input__slot { border-radius: 10px !important; }
.company-chip {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-size: 12px !important;
  font-weight: 500 !important; border-radius: 8px !important;
}

.modal-footer {
  display: flex; align-items: center; justify-content: flex-end;
  gap: 8px; padding: 14px 20px;
}
.modal-cancel-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 500 !important;
  text-transform: none !important; color: #64748b !important; border-radius: 10px !important;
}
.modal-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 600 !important;
  text-transform: none !important; border-radius: 10px !important;
  height: 40px !important; padding: 0 20px !important;
  box-shadow: 0 2px 8px rgba(21,101,192,0.3) !important;
}
</style>
